<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/>
<path style="fill:#D80027;" d="M0,256.001C0,114.616,114.616,0,256,0s256,114.616,256,256.001"/>
<g>
	<path style="fill:#F0F0F0;" d="M155.826,133.564c0-37.298,26.213-68.456,61.217-76.101c-5.38-1.174-10.961-1.811-16.696-1.811
		c-43.031,0-77.913,34.882-77.913,77.913s34.882,77.913,77.913,77.913c5.733,0,11.315-0.637,16.696-1.812
		C182.039,202.021,155.826,170.863,155.826,133.564z"/>
	<polygon style="fill:#F0F0F0;" points="256,61.217 261.526,78.222 279.407,78.222 264.94,88.733 270.466,105.738 256,95.229 
		241.534,105.738 247.06,88.733 232.594,78.222 250.474,78.222 	"/>
	<polygon style="fill:#F0F0F0;" points="212.625,94.608 218.15,111.614 236.031,111.614 221.565,122.124 227.091,139.129 
		212.625,128.62 198.157,139.129 203.684,122.124 189.217,111.614 207.098,111.614 	"/>
	<polygon style="fill:#F0F0F0;" points="299.376,94.608 304.903,111.614 322.783,111.614 308.316,122.124 313.843,139.129 
		299.376,128.62 284.91,139.129 290.436,122.124 275.97,111.614 293.85,111.614 	"/>
	<polygon style="fill:#F0F0F0;" points="282.681,144.695 288.207,161.701 306.087,161.701 291.621,172.211 297.147,189.216 
		282.681,178.707 268.215,189.216 273.741,172.211 259.275,161.701 277.154,161.701 	"/>
	<polygon style="fill:#F0F0F0;" points="229.32,144.695 234.845,161.701 252.727,161.701 238.26,172.211 243.787,189.216 
		229.32,178.707 214.853,189.216 220.379,172.211 205.913,161.701 223.794,161.701 	"/>
</g>

</svg>